/*
Color-stop approximations of the backend colormap presets, for swatches in
the colormap pickers. These are previews only — the exact server-side
rendering (including non-linear ramps like rain_radar) shows up in the
preview image, so a reasonable approximation is fine here.
*/

const PRESET_STOPS: Record<string, string[]> = {
  // Domain presets
  // Even value samples (every ~9.6 °C) of the banded -40..46 °C scale:
  // pale pink, fuchsia, indigo, blues, greens, yellow, orange, red, violet.
  temperature: [
    '#d9acb8',
    '#c74abe',
    '#000b8b',
    '#2768c0',
    '#76b8ad',
    '#c0e6ab',
    '#fff9b8',
    '#fdb468',
    '#e03c2c',
    '#c5a3d9',
  ],
  precipitation: [
    '#f7fbff',
    '#c6dbef',
    '#6baed6',
    '#2171b5',
    '#08306b',
    '#4a1486',
  ],
  rain_radar: [
    '#88e788',
    '#2fb82f',
    '#f9f106',
    '#f7a708',
    '#e63946',
    '#b5179e',
  ],
  // Windy-style value-anchored ramp (backend !411); representative hues
  // rather than even samples — the swatch is a preview, and even sampling
  // would collapse the warm mid-range into muted purples.
  wind_speed: [
    '#6271b7',
    '#53a553',
    '#a79d51',
    '#af5088',
    '#754a93',
    '#b693c0',
  ],
  pressure: ['#3b4cc0', '#8db0fe', '#f7f7f7', '#f4987a', '#b40426'],
  humidity: ['#8c510a', '#d8b365', '#f6e8c3', '#c7eae5', '#5ab4ac', '#01665e'],
  cloud_cover: ['#0d47a1', '#64b5f6', '#cfd8dc', '#f5f5f5', '#ffffff'],
  aqi: ['#00e400', '#ffff00', '#ff7e00', '#ff0000', '#8f3f97', '#7e0023'],
  // Matplotlib built-ins
  viridis: ['#440154', '#414487', '#2a788e', '#22a884', '#7ad151', '#fde725'],
  plasma: ['#0d0887', '#6a00a8', '#b12a90', '#e16462', '#fca636', '#f0f921'],
  inferno: ['#000004', '#420a68', '#932667', '#dd513a', '#fca50a', '#fcffa4'],
  magma: ['#000004', '#3b0f70', '#8c2981', '#de4968', '#fe9f6d', '#fcfdbf'],
  coolwarm: ['#3b4cc0', '#8db0fe', '#dddddd', '#f4987a', '#b40426'],
};

// Neutral fallback for presets the backend may add before this list learns
// about them.
export const COLORMAP_FALLBACK_STOPS = ['#9e9e9e', '#e0e0e0'];

export const presetGradientStops = (preset: string): string[] =>
  PRESET_STOPS[preset] ?? COLORMAP_FALLBACK_STOPS;
